module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_bike_08d687bc2fb6865b95eae8fc42e5d82e.png";